import { Box, Grid } from "@chakra-ui/react";
import { FeedCardIcon } from "src/components/feed-card/content-blocks/icon/feed-card-icon";
import { FeedCardNumber } from "src/components/feed-card/content-blocks/number/feed-card-number";
import { FeedCardPrice } from "src/components/feed-card/content-blocks/price/feed-card-price";
import { FeedCardText } from "src/components/feed-card/content-blocks/text/feed-card-text";
import { IFeedCardTableBody, TFeedCardTableContentBlock, TFeedCardTableHeaderItem } from "src/components/feed-card/types/content";
import { EnumFeedCardBlockType } from "src/components/feed-card/types/enums";

const FeedTableContentBlock = ({ type, body }: TFeedCardTableContentBlock) => {
    switch (type) {
        case EnumFeedCardBlockType.Text:
            return <FeedCardText as="span" value={body} />;
        case EnumFeedCardBlockType.Number:
            return <FeedCardNumber {...body} />;
        case EnumFeedCardBlockType.Price:
            return <FeedCardPrice {...body} />;
        default:
            return <UnsupportedContentType type={type} />;
    }
};

const UnsupportedContentType = ({}: { type: never }) => null;

const FeedTableHeaderItem = ({ type, body }: TFeedCardTableHeaderItem) => {
    switch (type) {
        case EnumFeedCardBlockType.Text:
            return <FeedCardText as="span" value={body} />;
        case EnumFeedCardBlockType.Icon:
            return <FeedCardIcon icon={body} />;
        default:
            return null;
    }
};

export const FeedCardTable = ({ rows, header }: IFeedCardTableBody) => {
    return (
        <Grid role="table" width="100%" gridTemplateColumns="auto auto" fontSize="sm">
            {header && (
                <Box role="row" display="contents">
                    {header.map((item, cellIndex) => {
                        const textAlignment = cellIndex === 0 ? "left" : "right";
                        return (
                            <Box
                                key={`${cellIndex}${item.type}`}
                                role="cellheader"
                                py={0.5}
                                overflow="hidden"
                                textOverflow="ellipsis"
                                whiteSpace="nowrap"
                                fontWeight="bold"
                                textAlign={textAlignment}
                            >
                                <FeedTableHeaderItem {...item} />
                            </Box>
                        );
                    })}
                </Box>
            )}
            {rows.map((row, rowIndex) => (
                <Box role="row" display="contents" key={rowIndex}>
                    {row.map((item, cellIndex) => {
                        const isItemInOddRow = rowIndex % 2 === 0;
                        const isFirstCell = cellIndex === 0;
                        const cellRole = isFirstCell ? "rowheader" : "cell";
                        const textAlignment = isFirstCell ? "left" : "right";
                        const backgroundColor = isItemInOddRow ? "gray.50" : undefined;

                        return (
                            <Box
                                key={`${rowIndex}${cellIndex}${item.type}`}
                                role={cellRole}
                                p={0.5}
                                overflow="hidden"
                                textOverflow="ellipsis"
                                whiteSpace="nowrap"
                                backgroundColor={backgroundColor}
                                textAlign={textAlignment}
                            >
                                <FeedTableContentBlock {...item} />
                            </Box>
                        );
                    })}
                </Box>
            ))}
        </Grid>
    );
};
